import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useTeamMember from '@hooks/useTeamMember'
import useTeamMembers from '@hooks/useTeamMembers'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import TeamMemberListItem from './components/TeamMemberListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Full Name',
    },
  ]
}

interface TeamMembersProps {
  teamId: number,
}

const TeamMembers = (props: TeamMembersProps) => {
  const { teamId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const teamMembersPayload = useTeamMembers({
    filters: {
      team_id: teamId,
      ...pageFilters,
    },
    performHttpRequests: !!teamId,
    requestOptions: defaultRequestOptions.teamMember,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredTeamMembers,
    filteredTeamMembersCount,
    hasFilteredTeamMembers,
    loading,
  } = teamMembersPayload

  const teamMemberPayload = useTeamMember({ team_id: teamId })
  const {
    callbacks: {
      createOrEditAgencyTeamMember,
    },
  } = teamMemberPayload

  return (
    <DashboardModule
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Team Members"
    >
      <Box flexDirection="column">
        <DashboardModuleFilters
          filterFields={buildPageFilterFields()}
          {...filterPayload}
        />

        {!loading && !hasFilteredTeamMembers && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Team Members present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please adjust your filters.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredTeamMembers && (
          <DashboardModule.ScrollableSection>
            {filteredTeamMembers.map(teamMember => (
              <TeamMemberListItem
                key={teamMember.id}
                teamMember={teamMember}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredTeamMembersCount}
          loading={loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditAgencyTeamMember()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Team Member
          </Button>
        </DashboardModule.LoadMoreFooter>

      </Box>
    </DashboardModule>
  )
}

export default TeamMembers
